import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import * as aspSettings from '../../asp/aspSettings';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { Animations } from './../../Animations';

@Component({
  selector: 'dialog-header',
  templateUrl: './dialog-header.component.html',
  styleUrls: ['../../../global.scss'],
  animations: [
    Animations.ColorRedExitButton,
    Animations.ColorBlueButton
  ]
})
export class DialogHeaderComponent {

  @Input() label: string = ''; 
  @Input() dialogRef: MatDialogRef<any>;
  @Input() autoClose: boolean = true;
  @Input() object: any = null;
  @Input() objectType: string = "";
  @Output() onClose: EventEmitter<any> = new EventEmitter<any>();

  isRed: boolean = false;
  isBlue: Array<boolean> = [false, false, false, false];

  // Buttons Flags
  public CenterFlag: boolean = false;
  public DCenterFlag: boolean = false;
  public SelectFlag: boolean = false;
  public HistoryFlag: boolean = false;

  // Icon Selection For Dynamic Center Icon (On/Off)
  public DCenterIconOp: string[] = ["gps_fixed", "gps_off"];
  public DCFlag: number = 0;

  constructor() {
  }

  ngOnInit(): void {
    if (this.objectType.toLowerCase() == "track") {
      this.CenterFlag = true;
      this.DCenterFlag = true;
      this.SelectFlag = true;
      this.HistoryFlag = true;
    }
    if (this.objectType.toLowerCase() == "plot" || this.objectType.toLowerCase() == "sensor" || this.objectType.toLowerCase() == "angtrack") {
      this.CenterFlag = true;
      this.SelectFlag = true;
    }
  }

  checkIdValid(id) {
    if (id != null)
      if (id != undefined)
        return true;
    return false;
  }

  onCloseBtnClick() {
    this.onClose.emit();
    if (this.object)
      if (this.object.windowVisible)
        this.object.windowVisible.next(false);
    setTimeout(() => {
      if (this.autoClose)
        this.dialogRef.close();
    }, 200);
  }

  onCenterClick() {
    if (!this.object || this.objectType == "")
      return;
    this.object.onCenterBtnClick();
  }

  onDCenterClick() {
    if (!this.object || this.objectType != "Track")
      return;
    this.DCFlag = this.DCFlag ? 0 : 1;
    this.object.onDynamicCenterBtnClick();
  }

  onHistoryClick() {
    if (!this.object || this.objectType != "Track")
      return;
    // this.DCFlag = this.DCFlag ? 0 : 1;
    this.object.onHistoryBtnClick();
  }

  onSelectedClick() {
    aspSettings.clearSelectedIds();
    let id;
    id = this.object.getID();
    if (this.checkIdValid(id)) {
      aspSettings.selectedIds.add(id);

      if (this.objectType.toLowerCase() == "track") {
        this.object.track.setHooked(true);
      }
      if (this.objectType.toLowerCase() == "plot") {
        this.object.plot.setHooked(true);
      }
      if (this.objectType.toLowerCase() == "sensor") {
        this.object.sensor.setHooked(true);
      }
      return;
    }
  }
}
